import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import CustomModal from 'components/global/CustomModal'
import React, { useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import CheckInOutTab from '../Common/CheckInOutTab'
import HistoryTab from '../Common/HistoryTab'

const DropInDetailModal = () => {
  const [tabKey, setTabKey] = useState<string>('1')
  const {
    detailedDropInModalOpen,
    setDetailedDropInModalOpen,
    setDropInModalOpen,
  } = eventAttendanceStore(store => ({
    detailedDropInModalOpen: store.detailedDropInModalOpen,
    setDetailedDropInModalOpen: store.setDetailedDropInModalOpen,
    setDropInModalOpen: store.setDropInModalOpen,
  }))

  const closeModal = () => {
    // setDropInModalOpen(true)
    setDetailedDropInModalOpen(false)
  }

  return (
    <CustomModal
      openModal={detailedDropInModalOpen}
      isCloseModalCustom
      closeModal={closeModal}
      title="Drop-in details"
      width={1200}
      footer={false}
    >
      <>
        <Tabs className="" defaultActiveKey={tabKey}>
          <TabPane tab="Drop-in" key="1">
            <CheckInOutTab type="drop-in" />
          </TabPane>
          <TabPane tab="History" key="2">
            <HistoryTab />
          </TabPane>
        </Tabs>
      </>
    </CustomModal>
  )
}

export default DropInDetailModal
